var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { manageService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var UserDeviceService = /** @class */ (function (_super) {
    __extends(UserDeviceService, _super);
    function UserDeviceService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 设备锁查询
     */
    UserDeviceService.prototype.findAllUserDevice = function (userId, loading) {
        return this.netService.send({
            server: manageService.userDeviceController.findAllUserDevice,
            data: {
                userId: userId
            },
            loading: loading
        });
    };
    /**
     * 一键启/禁用设备锁
     */
    UserDeviceService.prototype.batchDeviceManage = function (status, loading) {
        return this.netService.send({
            server: manageService.userDeviceController.batchDeviceManage,
            data: {
                status: status
            },
            loading: loading
        });
    };
    /**
     * 启用/禁用设备
     */
    UserDeviceService.prototype.modifyStatus = function (data, loading) {
        return this.netService.send({
            server: manageService.userDeviceController.modifyStatus,
            data: data,
            loading: loading
        });
    };
    /**
     * 重置设备
     */
    UserDeviceService.prototype.deleteUserDevice = function (userDeviceId, loading) {
        return this.netService.send({
            server: manageService.userDeviceController.deleteUserDevice,
            data: {
                userDeviceId: userDeviceId
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], UserDeviceService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "findAllUserDevice", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "batchDeviceManage", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "modifyStatus", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "deleteUserDevice", null);
    return UserDeviceService;
}(Service));
export { UserDeviceService };
